import { Link } from "react-router-dom";
import logo from "../res/ajorist-wt.png";

function Footer() {
  return (
    <footer id="footer" className="bg-slate-900 text-slate-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="md:col-span-2 lg:col-span-1">
            <a href="/journal" className="inline-block mb-4">
              <img className="h-16" src={logo} alt="AJORIST Logo" />
            </a>
            <p className="text-sm text-slate-400 leading-relaxed">
              The Asian Journal of Research in Science and Technology (AJORIST)
              is a prestigious online research journal promoting scientific
              knowledge and technological innovations.
            </p>

          </div>


          {/* Contact Section */}
          <div>
            <h3 className="text-sm font-semibold text-slate-200 uppercase tracking-wider">
              Contact Us
            </h3>
            <div className="mt-4 space-y-3 text-sm">
              <p className="leading-relaxed">
                Datu Gonsi St.,
                <br />
                Lomidong, Marawi City,
                <br />
                Philippines
              </p>
              <p>
                <span className="font-semibold text-slate-300">Mobile:</span>
                <a
                  href="tel:+639126862990"
                  className="ml-2 hover:text-sky-300 hover:underline"
                >
                  +63 912-686-2990
                </a>
              </p>
              <div>
                <p className="font-semibold text-slate-300">Email:</p>
                <a
                  href="mailto:ajorist@peaci.edu.ph"
                  className="block hover:text-sky-300 hover:underline"
                >
                  ajorist@peaci.edu.ph
                </a>
                <a
                  href="mailto:abdani.bandera@peaci.edu.ph"
                  className="block hover:text-sky-300 hover:underline"
                >
                  abdani.bandera@peaci.edu.ph
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-slate-200 uppercase tracking-wider">
              Quick Links
            </h3>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a
                  className="hover:text-sky-300 hover:underline"
                  href="/journal#about"
                >
                  About the Journal
                </a>
              </li>
              <li>
                <a
                  className="hover:text-sky-300 hover:underline"
                  href="/journal#publisher"
                >
                  About the Publisher
                </a>
              </li>
              <li>
                <a
                  className="hover:text-sky-300 hover:underline"
                  href="/journal#editorial"
                >
                  Editorial Board
                </a>
              </li>

              <li>
                <Link to="/" className="hover:text-sky-300 hover:underline">
                 PEACI Home Page
            </Link>
              </li>
            </ul>
          </div>

          {/* Developer & Admin */}
          <div>
            <h3 className="text-sm font-semibold text-slate-200 uppercase tracking-wider">
              Developer
            </h3>
            <p className="mt-4 text-sm font-medium text-white">
              Mellhabib M. Angni
            </p>
            <div className="mt-4 text-sm">
              <a
                className="text-slate-400 hover:text-sky-300 hover:underline"
                href="/journal/admin"
              >
                Web Admin Login
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-xs text-slate-500 text-center sm:text-left">
            Copyright © {new Date().getFullYear()} Asian Journal of Research in
            Science and Technology. All Rights Reserved.
          </p>
          <div className="flex items-center space-x-4 mt-4 sm:mt-0">
            <a
              href="https://www.facebook.com/PEACIofficial"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-500 hover:text-sky-400 transition-colors"
              aria-label="Facebook"
            >
              <svg
                className="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                fill="currentColor"
              >
                <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
